<template>
    <footer class="gz-footer">
        <div class="gz-footer__container gz-page__width">
            <GZ-Copyrights />
        </div>
    </footer>
</template>

<script>
export default {
    name: 'Footer'
}
</script>